import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  TSFWDRNewRequestControlName,
  TSFWDRNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class TSFWDRNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<TSFWDRNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [TSFWDRNewRequestControlName.OwnerOtherThanApplicant]:
        this.formBuilder.control(getDefaultControlValue()),
      [TSFWDRNewRequestControlName.Trees]: this.formBuilder.array([]),
      [TSFWDRNewRequestControlName.Shrubs]: this.formBuilder.array([]),
      [TSFWDRNewRequestControlName.RemovalReason]: this.formBuilder.control(
        getDefaultControlValue(),
        [Validators.required],
      ),
      [TSFWDRNewRequestControlName.PlannedDate]: this.formBuilder.control(
        getDefaultControlValue(),
        [Validators.required],
      ),
    });
  }
}
